var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();

//showMovie
import {showMovie} from "../include/module";
showMovie();

//showImg
import {showImg} from "../include/module";
showImg();

//tabSwitching
import {tabSwitching} from "../include/module";
tabSwitching();



$(window).on('load' , function() {

  scrollCommonAnime();

});

// ------------------------------------------------------------------------
// scrollCommonAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollCommonAnime = () => {

  const controller = new ScrollMagic.Controller();

  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'#index-Contents',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#st-Top', 'st-Top-Show')
  .addTo(controller);

  //ハンバーガー出現
  new ScrollMagic.Scene({
    // triggerElement:'#entry',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle("#st-Menu", "st-Menu-show")
  .addTo(controller);

  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene3 = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .97
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

};


// WEBPACK FOOTER //
// ./src/assets/js/update/script.js